import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  // mode: "history",
  scrollBehavior: (to, _, savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    } else if (to.params.offsetTop) {
      return new Promise(resolve => {
        setTimeout(() => {
          resolve({
            x: 0,
            y: to.params.offsetTop,
            behavior: "smooth"
          });
          // window.scroll({
          //   top: to.params.offsetTop,
          //   left: 0,
          //   behavior: 'smooth'
          // })
        }, 200);
      });
    }
  },
  routes: [
    {
      path: "/PC/360/RPA",
      component: () => import("@/views/leafLet/WFZX")
    },
    {
      path: "/PC/360/WFZX",
      component: () => import("@/views/leafLet/RPAcom")
    },

    {
      path: "/taxReceipt",
      component: () => import("@/views/leafLet/taxReceipt"),
      meta: {
        title: "微风企财税票智能处理系统",
        content: {
          keywords:
            "税务数据采集/信贷风控建模/企业贷前审查/贷前风险监测/企业征信评估/银行信贷产品匹配/企业税务风险检测",
          description:
            "微风企发票税务数据采集/信贷风控建模/企业贷前审查/贷前风险监测/企业征信评估（面向银行金融供应链相关业务），以及银行信贷产品匹配（面向助贷机构）、企业税务风险检测（面向财税公司） 、企业报告等等"
        }
      }
    },
    {
      path: "/taxReceipt/freeExperience",
      name: "freeExperience",
      component: () =>
        import("@/views/leafLet/taxReceiptComponents/freeExperience")
    },
    {
      path: "/",
      redirect: "/",
      component: () => import("@/views/layout/index"),
      children: [
        {
          name: "关于我们",
          path: "/aboutUs",
          redirect: "/introduce",
          component: () => import("@/views/aboutUs/index"),
          children: [
            {
              name: "新闻中心",
              path: "/news",
              component: () => import("@/views/aboutUs/news"),
              children: [
                {
                  path: "/",
                  // name: '新闻中心',
                  component: () => import("@/views/aboutUs/newShow/show")
                },
                {
                  path: "detail/:id",
                  name: "详情",
                  component: () => import("@/views/aboutUs/newShow/detail")
                }
              ]
            },
            {
              name: "公司介绍",
              path: "/introduce",
              component: () => import("@/views/aboutUs/introduce")
            }
          ]
        },
        {
          name: "产品中心",
          path: "/product",
          redirect: "/finance",
          component: () => import("@/views/product/index"),
          children: [
            // {
            //   name: '新金融风控体系产品',
            //   path: '/finance',
            //   component: () => import('@/views/product/finance')
            // },
            // {
            //   name: '商业增信决策产品',
            //   path: '/business',
            //   component: () => import('@/views/product/business')
            // },
            // {
            //   name: '模块化与定制化产品',
            //   path: '/modular',
            //   component: () => import('@/views/product/modular')
            // },
            {
              name: "财税票RPA智能处理系统",
              path: "/tax",
              component: () => import("@/views/product/tax")
            },
            {
              name: "企业资信评估报告系统",
              path: "/credit",
              component: () => import("@/views/product/credit")
            },
            {
              name: "企业智能贷后管理系统",
              path: "/loan",
              component: () => import("@/views/product/loan")
            },
            {
              name: "智能信贷产品匹配系统",
              path: "/smartCredit",
              component: () => import("@/views/product/smartCredit")
            }
          ]
        },
        {
          name: "解决方案",
          path: "/solution",
          redirect: "/authentication",
          component: () => import("@/views/solution/index"),
          children: [
            {
              name: "企业数字化资质认证解决方案",
              path: "/authentication",
              component: () => import("@/views/solution/authentication")
            },
            {
              // name: "普惠金融智能风控解决方案",
              name: "金融智能风控解决方案",
              path: "/intelligence",
              component: () => import("@/views/solution/intelligence")
            },
            {
              name: "企业信用及风险咨询解决方案",
              path: "/risk",
              component: () => import("@/views/solution/risk")
            }
          ]
        },
        {
          name: "/",
          path: "/",
          component: () => import("@/views/home/index")
        },
        {
          name: "合作案例",
          path: "/cooperationCases",
          component: () => import("@/views/cooperation/index")
        }
      ]
    },
    {
      path: "/",
      name: "yAuth",
      component: () => import("@/pages/y-auth/y-auth"),
      children: [
        {
          path: "/y-auth",
          name: "yAuth",
          component: () => import("@/pages/y-auth/y-auth")
        }
      ]
    },
    {
      path: "/",
      name: "agre",
      component: () => import("@/pages/client-agre/ins-agre/ins-agre.vue"),
      children: [
        {
          path: "/ins-agre",
          name: "insAgre",
          component: () => import("@/pages/client-agre/ins-agre/ins-agre.vue")
        }
      ]
    },
    {
      path: "/",
      name: "agre",
      component: () =>
        import("@/pages/client-agre/privacy-agre/privacy-agre.vue"),
      children: [
        {
          path: "/privacy-agre",
          name: "privacyAgre",
          component: () =>
            import("@/pages/client-agre/privacy-agre/privacy-agre.vue")
        }
      ]
    },
    {
      path: "/",
      name: "agre-wfx",
      component: () => import("@/pages/client-agre/ins-agre-wfx/ins-agre.vue"),
      children: [
        {
          path: "/ins-agre-wfx",
          name: "insAgre",
          component: () =>
            import("@/pages/client-agre/ins-agre-wfx/ins-agre.vue")
        }
      ]
    },
    {
      path: "/",
      name: "agre-wfx",
      component: () =>
        import("@/pages/client-agre/privacy-agre-wfx/privacy-agre.vue"),
      children: [
        {
          path: "/privacy-agre-wfx",
          name: "privacyAgre",
          component: () =>
            import("@/pages/client-agre/privacy-agre-wfx/privacy-agre.vue")
        }
      ]
    },
    {
      path: "/",
      name: "ins-agre-zsapi",
      component: () => import("@/pages/client-agre/ins-agre-zsapi/ins-agre.vue"),
      children: [
        {
          path: "/ins-agre-zsapi",
          name: "insAgre",
          component: () =>
            import("@/pages/client-agre/ins-agre-zsapi/ins-agre.vue")
        }
      ]
    },
    {
      path: "/",
      name: "privacy-agre-zsapi",
      component: () =>
        import("@/pages/client-agre/privacy-agre-zsapi/privacy-agre.vue"),
      children: [
        {
          path: "/privacy-agre-zsapi",
          name: "privacyAgreZsapi",
          component: () =>
            import("@/pages/client-agre/privacy-agre-zsapi/privacy-agre.vue")
        }
      ]
    },
    {
      path: "/",
      name: "agre-agent",
      component: () =>
        import("@/pages/client-agre/ins-agre-agent/ins-agre.vue"),
      children: [
        {
          path: "/ins-agre-agent",
          name: "insAgreAgent",
          component: () =>
            import("@/pages/client-agre/ins-agre-agent/ins-agre.vue")
        }
      ]
    },
    {
      path: "/",
      name: "agre-agent",
      component: () =>
        import("@/pages/client-agre/privacy-agre-agent/privacy-agre.vue"),
      children: [
        {
          path: "/privacy-agre-agent",
          name: "privacyAgreAgent",
          component: () =>
            import("@/pages/client-agre/privacy-agre-agent/privacy-agre.vue")
        }
      ]
    },
    // {
    //   path: "/",
    //   name: "agre-agent-dark",
    //   component: () =>
    //     import("@/pages/client-agre/privacy-agre-agent-dark/privacy-agre.vue"),
    //   children: [
    //     {
    //       path: "/privacy-agre-agent-dark",
    //       name: "privacyAgreAgentDark",
    //       component: () =>
    //         import("@/pages/client-agre/privacy-agre-agent-dark/privacy-agre.vue")
    //     }
    //   ]
    // },
    // agent注销协议
    {
      path: "/",
      name: "agre-agent",
      component: () =>
        import("@/pages/client-agre/cancellation-agre-agent/cancellation-agre-agent.vue"),
      children: [
        {
          path: "/cancellation-agre-agent",
          name: "cancellationAgreAgent",
          component: () =>
            import("@/pages/client-agre/cancellation-agre-agent/cancellation-agre-agent.vue")
        }
      ]
    },
    // agent隐私协议
    {
      path: "/client-download",
      name: "client-download",
      component: () => import("@/pages/client-download/index.vue")
    },
    {
      path: "/wbit-invite",
      name: "wbit-invte",
      component: () => import("@/pages/wbit-invite/index.vue")
    },
    {
      path: "/wbit-invite-analyze",
      name: "wbit-invite-analyze",
      component: () => import("@/pages/wbit-invite-analyze/index.vue")
    },
    {
      path: "/",
      name: "userLayout",
      component: () => import("@/views/userLayout/index"),
      children: [
        {
          path: "/register",
          name: "register",
          component: () => import("@/views/register/register")
        },
        {
          path: "/login",
          name: "login",
          component: () => import("@/views/login/login")
        },
        {
          path: "/stage",
          name: "stage",
          component: () => import("@/views/stage/stage")
        }
      ]
    },
    {
      path: "/forbiddenPage",
      name: "forbiddenPage",
      component: () => import("@/views/demo/forbiddenPage")
    },
    {
      path: "/demo",
      name: "demo",
      meta: {
        title: "示例报告"
      },
      redirect: "/demo/accessDenied",
      component: () => import("@/views/demo/demo"),
      children: [
        {
          path: "accessDenied",
          name: "accessDenied",
          meta: {
            title: "无权访问"
          },
          component: () => import("@/views/demo/accessDenied")
        },
        {
          path: "preLoanReport",
          name: "preLoanReport",
          meta: {
            title: "贷前示例报告"
          },
          redirect: "/demo/preLoanReport/preLoanReportBaseInfo",
          component: () => import("@/views/demo/newPreReport/report"),
          children: [
            {
              path: "preLoanReportBaseInfo",
              name: "preLoanReportBaseInfo",
              meta: {
                title: "基本信息"
              },
              component: () =>
                import("@/views/demo/preLoan/preLoanReportBaseInfo")
            },
            {
              path: "preLoanReportMarketAnalysis",
              name: "preLoanReportMarketAnalysis",
              meta: {
                title: "销售分析"
              },
              component: () =>
                import("@/views/demo/preLoan/preLoanReportMarketAnalysis")
            },
            {
              path: "preLoanReportProductAnalysis",
              name: "preLoanReportProductAnalysis",
              meta: {
                title: "产品分析"
              },
              component: () =>
                import("@/views/demo/preLoan/preLoanReportProductAnalysis")
            },
            {
              path: "preLoanReportFinanceAnalysis",
              name: "preLoanReportFinanceAnalysis",
              meta: {
                title: "财务分析"
              },
              component: () =>
                import("@/views/demo/preLoan/preLoanReportFinanceAnalysis")
            },
            {
              path: "preLoanReportIndustryInfo",
              name: "preLoanReportIndustryInfo",
              meta: {
                title: "行业信息"
              },
              component: () =>
                import("@/views/demo/preLoan/preLoanReportIndustryInfo")
            },
            {
              path: "invoiceData",
              name: "invoiceData",
              meta: {
                title: "发票原始数据"
              },
              redirect: "/demo/preLoanReport/invoiceData/invoiceDataInput",
              component: () =>
                import("@/views/demo/preLoan/invoiceData/invoiceData"),
              children: [
                {
                  path: "invoiceDataInput",
                  name: "invoiceDataInput",
                  meta: {
                    title: "进项发票"
                  },
                  component: () =>
                    import("@/views/demo/preLoan/invoiceData/invoiceDataInput"),
                  children: [
                    {
                      path: "invoiceDataInputDetail",
                      name: "invoiceDataInputDetail",
                      meta: {
                        title: "详情"
                      },
                      component: () =>
                        import("@/views/demo/preLoan/invoiceData/invoiceDataInputDetail")
                    }
                  ]
                },
                {
                  path: "invoiceDataOutput",
                  name: "invoiceDataOutput",
                  meta: {
                    title: "销项发票"
                  },
                  component: () =>
                    import("@/views/demo/preLoan/invoiceData/invoiceDataOutput"),
                  children: [
                    {
                      path: "invoiceDataOutputDetail",
                      name: "invoiceDataOutputDetail",
                      meta: {
                        title: "详情"
                      },
                      component: () =>
                        import("@/views/demo/preLoan/invoiceData/invoiceDataOutputDetail")
                    }
                  ]
                },
                {
                  path: "invoiceDataOutputAllDetail",
                  name: "invoiceDataOutputAllDetail",
                  meta: {
                    title: "销项发票详情"
                  },
                  component: () =>
                    import("@/views/demo/preLoan/invoiceData/invoiceDataOutputAllDetail")
                },
                {
                  path: "invoiceDataInputAllDetail",
                  name: "invoiceDataInputAllDetail",
                  meta: {
                    title: "进项发票详情"
                  },
                  component: () =>
                    import("@/views/demo/preLoan/invoiceData/invoiceDataInputAllDetail")
                }
              ]
            },
            {
              path: "taxData",
              name: "taxData",
              meta: {
                title: "税务原始数据"
              },
              component: () => import("@/views/demo/preLoan/taxData/taxData"),
              children: [
                {
                  path: "vatDeclarationSmallScale",
                  name: "vatDeclarationSmallScale",
                  meta: {
                    title: "增值税"
                  },
                  component: () =>
                    import("@/views/demo/preLoan/taxData/taxDetail/vatDeclarationSmallScale")
                },
                {
                  path: "corporateIncomeTaxYearDeclaration",
                  name: "corporateIncomeTaxYearDeclaration",
                  meta: {
                    title: "企业所得税"
                  },
                  component: () =>
                    import("@/views/demo/preLoan/taxData/taxDetail/corporateIncomeTaxYearDeclaration")
                },
                {
                  path: "finance2013Balance",
                  name: "finance2013Balance",
                  meta: {
                    title: "资产负债表"
                  },
                  component: () =>
                    import("@/views/demo/preLoan/taxData/taxDetail/finance2013Balance")
                },
                {
                  path: "finance2013Profit",
                  name: "finance2013Profit",
                  meta: {
                    title: "利润表"
                  },
                  component: () =>
                    import("@/views/demo/preLoan/taxData/taxDetail/finance2013Profit")
                },
                {
                  path: "paymentInfo",
                  name: "paymentInfo",
                  meta: {
                    title: "员工人数及社保基数"
                  },
                  component: () =>
                    import("@/views/demo/preLoan/taxData/taxDetail/paymentInfo")
                },
                {
                  path: "socialSecurityDeclaration",
                  name: "socialSecurityDeclaration",
                  meta: {
                    title: "完税信息表"
                  },
                  component: () =>
                    import("@/views/demo/preLoan/taxData/taxDetail/socialSecurityDeclaration")
                },
                {
                  path: "arrearsTax",
                  name: "arrearsTax",
                  meta: {
                    title: "欠税信息表"
                  },
                  component: () =>
                    import("@/views/demo/preLoan/taxData/taxDetail/arrearsTax")
                },
                {
                  path: "qywzwfxx",
                  name: "qywzwfxx",
                  meta: {
                    title: "违法违章信息表"
                  },
                  component: () =>
                    import("@/views/demo/preLoan/taxData/taxDetail/qywzwfxx")
                }
              ]
            }
          ]
        },
        {
          path: "preReportV3",
          name: "preReportV3",
          meta: {
            title: "贷前示例报告V3"
          },
          // component: () => import('@/views/demo/postLoan/postLoanReport'),
          component: () => import("@/views/demo/preReportV3/index.vue")
        },
        {
          path: "postLoanReport",
          name: "postLoanReport",
          meta: {
            title: "贷后巡检示例报告"
          },
          // component: () => import('@/views/demo/postLoan/postLoanReport'),
          component: () => import("@/views/demo/postLoan/postLoanReportIframe")
        },
        {
          path: "enterpriseAnalysis",
          name: "enterpriseAnalysis",
          meta: {
            title: "产品匹配分析示例报告"
          },
          component: () =>
            import("@/views/demo/enterpriseAnalysis/enterpriseAnalysisReport")
        },
        {
          path: "trcReport",
          name: "trcReport",
          meta: {
            title: "税务风险体检示例报告"
          },
          component: () => import("@/views/demo/taxRisk/trcReport")
        },
        {
          path: "cloudTuneReport",
          name: "cloudTuneReport",
          meta: {
            title: "知秋信用示例报告"
          },
          component: () => import("@/views/demo/cloudTune/cloudTuneReport")
        },
        {
          path: "jcaReport",
          name: "jcaReport",
          meta: {
            title: "尽调服务示例报告"
          },
          component: () => import("@/views/demo/yunjindiaoSystem/jcaReport")
        },
        {
          path: "supplierReport",
          name: "supplierReport",
          meta: {
            title: "供应商尽调示例报告"
          },
          component: () =>
            import("@/views/demo/yunjindiaoSystem/supplierReport")
        },
        {
          path: "FSAReport",
          name: "FSAReport",
          meta: {
            title: "财政补贴示例报告"
          },
          component: () => import("@/views/demo/FSAReport/FSAReport")
        },
        {
          path: "bsReport",
          name: "bsReport",
          meta: {
            title: "经营参谋示例报告"
          },
          component: () => import("@/views/demo/businessStrategy/bsReport")
        },
        {
          path: "trGeneralist",
          name: "trGeneralist",
          meta: {
            title: "税务风险体检示例报告（新版）"
          },
          component: () => import("@/views/demo/taxRisk/trGeneralist")
        },
        {
          path: "investment",
          name: "investment",
          meta: {
            title: "投资尽调报告"
          },
          component: () => import("@/views/demo/investment/investment")
        },
        {
          path: "panoramic",
          name: "panoramic",
          meta: {
            title: "全景报告"
          },
          component: () => import("@/views/demo/panoramic/panoramic")
        },
        {
          path: "taxRiskPersonalReport",
          name: "taxRiskPersonalReport",
          meta: {
            title: "税务风险报告-专业版"
          },
          component: () =>
            import("@/views/demo/taxRiskPersonalReport/taxRiskPersonalReport")
        },
        {
          path: "taxRiskEcommerceReport",
          name: "taxRiskEcommerceReport",
          meta: {
            title: "税务风险服务-电商版"
          },
          component: () =>
            import("@/views/demo/taxRiskEcommerceReport/index")
        },
        {
          path: "financingMatchCustomReport",
          name: "financingMatchCustomReport",
          meta: {
            title: "融资匹配报告（千企千面版）"
          },
          component: () =>
            import("@/views/demo/financingMatchCustomReport/index")
        },
        {
          path: "industryChainReport",
          name: "industryChainReport",
          meta: {
            title: "产业链报告示例报告"
          },
          component: () =>
            import("@/views/demo/industryChainReport/index")
        },
        {
          path: "ocrEnterpriseCreditReport",
          name: "ocrEnterpriseCreditReport",
          meta: {
            title: "OCR-企业征信报告"
          },
          component: () =>
            import("@/views/demo/ocrEnterpriseCreditReport/index")
        },
        {
          path: "ocrPersonalCreditReport",
          name: "ocrPersonalCreditReport",
          meta: {
            title: "OCR-个人征信报告"
          },
          component: () =>
            import("@/views/demo/ocrPersonalCreditReport/index")
        },
        {
          path: "ocrBankStatementReport",
          name: "ocrBankStatementReport",
          meta: {
            title: "OCR-银行流水报告"
          },
          component: () =>
            import("@/views/demo/ocrBankStatementReport/index")
        },
        {
          path: "ocrFinancialReportAnalysis",
          name: "ocrFinancialReportAnalysis",
          meta: {
            title: "OCR-财报分析报告示例报告"
          },
          component: () =>
            import("@/views/demo/ocrFinancialReportAnalysis/index")
        }
      ]
    },
    {
      path: "/promotion",
      name: "promotion",
      meta: {
        title: "落地页"
      },
      component: () => import("@/views/promotion/promotion")
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js